import { render, staticRenderFns } from "./DetailTypeTwoGraph.vue?vue&type=template&id=d8b395ca&"
import script from "./DetailTypeTwoGraph.vue?vue&type=script&lang=js&"
export * from "./DetailTypeTwoGraph.vue?vue&type=script&lang=js&"
import style0 from "./DetailTypeTwoGraph.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports